import { useSeo } from "./Layout";

export const LegalPage = ({ title, updated, children, testid }) => (
  <div data-testid={testid}>
    <header className="bg-mist">
      <div className="container-x py-12 md:py-16 max-w-4xl">
        <p className="eyebrow">Informations légales</p>
        <h1 className="mt-4 text-4xl sm:text-5xl">{title}</h1>
        <p className="mt-4 text-slate-600">Dernière mise à jour : {updated}</p>
      </div>
    </header>
    <div className="container-x max-w-3xl py-12 md:py-16 legal">{children}</div>
  </div>
);

export const H2 = ({ children }) => <h2 className="mt-10 mb-4 text-2xl sm:text-3xl">{children}</h2>;
export const P = ({ children }) => <p className="mb-4 text-lg text-slate-700 leading-relaxed">{children}</p>;
export const UL = ({ items }) => <ul className="mb-5 list-disc pl-6 space-y-2 text-lg text-slate-700 marker:text-brand-ink">{items.map((i) => <li key={i}>{i}</li>)}</ul>;

export const useLegalSeo = (t, d) => useSeo(t, d);
